import { Pipe, PipeTransform } from "@angular/core";
import { format as _format, parseISO } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import enUS from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import it from "date-fns/locale/it";
import fr from "date-fns/locale/fr";
import ja from "date-fns/locale/ja";
import { TranslateService } from "@ngx-translate/core";
import { UserProvider } from "src/app/services/user/user";

const DATE_FORMATS: Record<string, Record<string, string>> = {
  pt: {
    completa: "EEEE d 'de' MMMM 'de' yyyy HH:mm",
    media: "EEE d 'de' MMM 'de' yyyy",
    mediaHora: "EEE d 'de' MMM 'de' yyyy 'às' HH:mm",
    ddmmyyyy: "dd/MM/yyyy",
    dataHora: "dd/MM/yyyy HH:mm",
    hora: "HH:mm",
    curta: "d 'de' MMM"
  },
  en: {
    completa: "EEEE, MMMM d, yyyy hh:mm a",
    media: "EEE, MMM d, yyyy",
    mediaHora: "EEE, MMM d yyyy hh:mm a",
    ddmmyyyy: "MM/dd/yyyy",
    dataHora: "MM/dd/yyyy hh:mm a",
    hora: "hh:mm a",
    curta: "MMM d"
  },
  es: {
    completa: "EEEE d 'de' MMMM 'de' yyyy HH:mm",
    media: "EEE d 'de' MMM 'de' yyyy",
    mediaHora: "EEE d 'de' MMM 'de' yyyy 'a las' HH:mm",
    ddmmyyyy: "dd/MM/yyyy",
    dataHora: "dd/MM/yyyy HH:mm",
    hora: "HH:mm",
    curta: "d 'de' MMM"
  },
  it: {
    completa: "EEEE d MMMM yyyy HH:mm",
    media: "EEE d MMM yyyy",
    mediaHora: "EEE d MMM yyyy HH:mm",
    ddmmyyyy: "dd/MM/yyyy",
    dataHora: "dd/MM/yyyy HH:mm",
    hora: "HH:mm",
    curta: "d MMM"
  },
  fr: {
    completa: "EEEE d MMMM yyyy HH:mm",
    media: "EEE d MMM yyyy",
    mediaHora: "EEE d MMM yyyy HH:mm",
    ddmmyyyy: "dd/MM/yyyy",
    dataHora: "dd/MM/yyyy HH:mm",
    hora: "HH:mm",
    curta: "d MMM"
  },
  ja: {
    completa: "EEEE, MMMM d, yyyy hh:mm a",
    media: "EEE, MMM d, yyyy",
    mediaHora: "EEE, MMM d yyyy hh:mm a",
    ddmmyyyy: "yyyy/MM/dd",
    dataHora: "yyyy/MM/dd hh:mm a",
    hora: "hh:mm a",
    curta: "MMM d"
  },
  ptPT: {
    completa: "EEEE, MMMM d, yyyy hh:mm a",
    media: "EEE, MMM d, yyyy",
    mediaHora: "EEE, MMM d yyyy hh:mm a",
    ddmmyyyy: "yyyy/MM/dd",
    dataHora: "yyyy/MM/dd hh:mm a",
    hora: "hh:mm a",
    curta: "d 'de' MMM"
  },

};

const LOCALES: Record<string, Locale> = {
  pt: ptBR,
  en: enUS,
  es,
  it,
  fr,
  ja,
};

@Pipe({
  name: "dateFormat",
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  constructor(private translate: TranslateService, private userProvider: UserProvider) {}

  transform(date: any, formatStr: string): string | null {
    if (!date) return null;
    
    const currentLang = this.userProvider.linguagem || "pt";

    const normalizedLang = currentLang.substring(0, 2).toLowerCase();

    const locale = LOCALES[normalizedLang] || ptBR;
    const formatkey = DATE_FORMATS[normalizedLang]?.[formatStr] || formatStr;

    try {
      const parsedDate = typeof date === "string" ? parseISO(date) : date;
      const formattedDate = _format(parsedDate, formatkey, { locale });

      return formattedDate
        .split(" ")
        .map((word, index) => 
         index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
        )
        .join(" ");
    } catch (error) {
      console.warn("Erro ao formatar data:", error);
      return String(date);
    }
  }
}